export const otherLimit = 1;

export const dietaryOrAllergySamples = [
  {
    label: 'Allergies',
    limit: 2,
    data: [
      { label: 'Peanuts', count: 1 },
      { label: 'Lactose Intolerant', count: 1 },
      { label: 'Mushrooms', count: 1 },
      { label: 'Shellfish', count: 1 },
      { label: 'Soy', count: 1 },
      { label: 'Eggs', count: 1 },
      { label: 'Wheat', count: 1 },
      { label: 'Gluten Free', count: 1 },
    ],
  },
  {
    label: 'Preferences',
    limit: 1,
    data: [
      { label: 'Diabetic', count: 1 },
      { label: 'Vegetarian', count: 1 },
      { label: 'Pescatarian', count: 1 },
      { label: 'Kosher', count: 1 },
      { label: 'Pregnant', count: 1 },
    ],
  },
];

export const occasionSamples = [
  {
    label: '',
    limit: 1,
    data: [
      { label: 'Birthday' },
      { label: 'Anniversary' },
      { label: 'Graduation' },
      { label: 'Engagement' },
      { label: 'Reunion' },
      { label: 'Promotion' },
      { label: 'Baby Shower' },
      { label: 'Bridal Shower' },
      { label: 'Wedding' },
    ],
  },
];
